var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTraderMarkW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6462_17921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 28C56 33.936 55.6844 39.6989 55.104 45.1971C54.5236 50.6953 50.4305 54.544 45.1971 55.104C39.7091 55.6945 33.9462 56 28 56C22.0538 56 16.3011 55.6844 10.8029 55.104C5.30473 54.5236 1.456 50.4305 0.896 45.1971C0.305455 39.7091 0 33.9462 0 28C0 22.0538 0.315636 16.3011 0.896 10.8029C1.47636 5.30473 5.56945 1.456 10.8029 0.896C16.2909 0.305455 22.0538 0 28 0C33.9462 0 39.6989 0.315636 45.1971 0.896C50.6953 1.47636 54.544 5.56945 55.104 10.8029C55.6945 16.2909 56 22.0538 56 28Z",
    fill: "url(#paint0_radial_6462_17921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5721 22.5438C43.7889 22.5438 44.4538 23.948 43.6864 24.8934L28.8309 43.1835C27.3239 45.0368 24.3758 43.4454 25.0966 41.1708L25.0868 41.162L30.6845 23.5458C30.8717 22.9467 31.4333 22.5438 32.0604 22.5438H42.5721ZM27.1669 12.8182C28.6739 10.9648 31.623 12.5563 30.9022 14.8309L30.912 14.8397L25.3143 32.4569C25.1271 33.0557 24.5653 33.4577 23.9384 33.4579H13.4257C12.2091 33.4575 11.5449 32.0535 12.3124 31.1083L27.1669 12.8182Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6462_17921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 67.285) rotate(-90) scale(103.281)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09218B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E155A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6462_17921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraderMarkW);
export default __webpack_public_path__ + "static/media/trader-mark-w.6afdd3c5bbbeb8355aba9fdf4e1ef347.svg";
export { ForwardRef as ReactComponent };